/**
 * Whether a video layer that has just ended should stay on screen.
 *
 * At a cut the outgoing clip is postmounted, which Remotion hides, and the
 * incoming clip shows an empty canvas until it decodes its first frame. When
 * that takes longer than the clip's premount window, the Player waits at the
 * cut and the viewer sees the background. Keeping the outgoing clip's frozen
 * last frame visible for that wait shows the last frame that was playing.
 *
 * Bounded to half a second after the clip's end so a later wait never
 * resurfaces it.
 */
export function holdsLastFrame({
  frame,
  layerEnd,
  fps,
  buffering,
}: {
  frame: number;
  /** First composition frame after the layer, `from + duration`. */
  layerEnd: number;
  fps: number;
  buffering: boolean;
}): boolean {
  if (!buffering) return false;
  const framesSinceEnd = frame - layerEnd;
  return framesSinceEnd >= 0 && framesSinceEnd < Math.ceil(fps / 2);
}
